import React, { useEffect, useState } from "react";
import axios from "axios";
import { Parallax } from "react-parallax";
import LoadingPage from "./LoadingPage";
import { useDocumentMeta } from '../useDocumentMeta';

function Detail(props) {
  window.scrollTo(0, 0);
  const [detailInfo, setDetailInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = async () => {
    try {
      setError(null);
      setDetailInfo(null);
      setLoading(true);
      const response = await axios.get(
        "https://api.0u0.kr/portfolio/detail/OilSagu"
      );
      setDetailInfo(response.data.data);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    //
  }, []);
  useDocumentMeta(detailInfo?.pjDetailBigName, detailInfo?.contentHdBgColor);

  if (loading) {
    return (
      <>
        <LoadingPage />
      </>
    );
  }
  if (error) return <div>에러가 발생했습니다.</div>;
  if (!detailInfo) return null;
  if (detailInfo) {
    props.setColorData(detailInfo.contentHdBgColor);
  }

  return (
    <>
      <div
        className="detailHeader"
        style={{ backgroundColor: detailInfo.contentBgColor }}
      >
        <div className="dhTb">
          <div className="dhTbCell">
            <div className="dhDiv">
              <div className="txtBox">
                <h3>{detailInfo.pjDetailSmName}</h3>
                <h1>{detailInfo.pjDetailBigName}</h1>
              </div>
              <div className="logoBox ">
                <div className="logoBoxPt">
                  <img
                    src={"https://img.0u0.kr/new_port/" + detailInfo.imgLogo}
                    alt={detailInfo.pjName + "의 로고"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <ul style={{ color: detailInfo.contentFontColor }}>
            <li>
              <div className="tit">카테고리</div>
              <h2>{detailInfo.tagName}</h2>
            </li>

            <li>
              <div className="tit">업무처</div>
              <h2>{detailInfo.teamName}</h2>
            </li>

            <li>
              <div className="tit">기간</div>
              <h2>{detailInfo.pjDate}</h2>
            </li>

            <li>
              <div className="tit">사용 툴/언어</div>
              <h2>{detailInfo.pjTool}</h2>
            </li>
          </ul>
        </div>
      </div>


      <Parallax
        bgImage="https://img.0u0.kr/new_port/5149_bg.jpg"
        strength={500}
        className="topmobiImgStyle"
      >
        <div className="parallaxHeight "></div>
      </Parallax>

      <div className="whiteBg" style={{paddingTop:'15px'}}>
        <div className="detailInfo basicWidth topImgTxtStyle">
          <div className="basicDetailTitleBox">
            <h2>데이터와 AI로 설계하는 스마트한 주유 생활</h2>
            <div className="txtBox">
              5149는 사용자 위치 기반으로 실시간 주유소 가격 정보를 표시하여 최적의 주유시점과 장소를 제안합니다. 지역 평균가 혹은 근처 주유소와의 비교 분석은 물론, 개인별 카드 할인 혜택을 적용하여 실질적인 가격 비교를 도와줍니다.
              단순한 가격 비교를 넘어, Python과 Google Gemma 4 기반으로 전 세계 유가 이슈, 국제 정세, 뉴스 등을 실시간으로 분석하여 리포트를 작성하여 유가변동 지수 점수를 내고 LightGBM을 활용하여 미래 가격을 예측하거나, 개별 주유소에대 분석하는 리포트 등을 제공하여
              편리한 유가 정보 플랫폼을 지향합니다.
            </div>
          </div>

          <div class="txtGroupBox" style={{textAlign:'center'}}>
            <h2 class="leftAlign" style={{fontSize:'1.7em', marginTop:'90px'}}>🚀 프로젝트 진행 사유</h2>
            <div style={{lineHeight:'150%', marginTop:'10px'}}>
              1. No-Ads 정책이면서 좀 더 쉽고, 유가 정보 분석만을 위한 플랫폼이 필요했음<br/>
              2. 최근에 새로산 서버 활용을 위해<br/>
              3. Gemini CLI, PostgreSQL, Gemma4, LightGBM 사용해보기 위해
            </div>
          </div>


          <div class="txtGroupBox" style={{textAlign:'center'}}>
            <h2 class="leftAlign" style={{fontSize:'1.7em', marginTop:'50px'}}>🛠️ 주요 기술 스택</h2>
            <div style={{lineHeight:'150%', marginTop:'10px'}}>
              Backend :  Node.JS<br/>
              FrontEnd : React 19, Rechart<br/>
              Data : Python, PostgreSQL, LightGBM
            </div>

          </div>


        </div>



      </div>

  <div class="whiteBg">
    <div class="detailInfo basicWidth topImgTxtStyle">
      <div class="basicDetailTitleBox">
        <div class="imgGroupBox mobiCont">
          <img src="https://img.0u0.kr/new_port/5149_last_img.jpg" class="bdImgBox" alt="" />
        </div>
      <div class="txtGroupBox classys">
        <h2 class="leftAlign">오일사구 접속</h2>
        <div class="txtBox">현재 5149.kr을 통해 서비스중입니다. 아래 버튼을 눌러 확인할 수 있습니다.
          <div class="linkBox">
            <a href="https://5149.kr" rel="noreferrer" target="_blank">서비스 접속</a>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>

    </>
  );
}
export default Detail;
